import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=63963992&scoped=true&"
import script from "./Cash.vue?vue&type=script&lang=js&"
export * from "./Cash.vue?vue&type=script&lang=js&"
import style0 from "./Cash.vue?vue&type=style&index=0&id=63963992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63963992",
  null
  
)

export default component.exports